import { api } from '../client';
import type { Event, Position, ReportStop, ReportSummary, ReportTrip } from '../types';

interface BaseParams {
  deviceId?: number | number[];
  groupId?: number | number[];
  /** ISO 8601 */
  from: string;
  /** ISO 8601 */
  to: string;
}

interface EventsParams extends BaseParams {
  type?: string | string[];
}

interface SummaryParams extends BaseParams {
  /** Traccar v4.10+ exige esse parâmetro. false = totais; true = um item por dia. */
  daily?: boolean;
}

export const reportsApi = {
  route: (params: BaseParams) => api.get<Position[]>('/reports/route', { query: params }),
  events: (params: EventsParams) => api.get<Event[]>('/reports/events', { query: params }),
  summary: (params: SummaryParams) =>
    api.get<ReportSummary[]>('/reports/summary', { query: { daily: false, ...params } }),
  trips: (params: BaseParams) => api.get<ReportTrip[]>('/reports/trips', { query: params }),
  stops: (params: BaseParams) => api.get<ReportStop[]>('/reports/stops', { query: params }),
};
